/*
 * The glyph is sized in `em`, so the only thing this sheet decides is which
 * step of the type scale the icon borrows. Colour is never set here: the SVG
 * paints with `currentColor` and inherits from whatever contains it.
 */
.sm {
  font-size: 0.875rem;
}

.md {
  font-size: 1rem;
}

.lg {
  font-size: 1.25rem;
}
